module.exports = __webpack_public_path__ + "img/icon7.8f038cf5.svg";